import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const acceptanceRouter: Array<RouteRecordRaw> = [
  {
    path: '/acceptance',
    component: Layout,
    redirect: 'noredirect',
    meta: {
      order: 5, // 承兑票管理 导航栏权重
      title: 'acceptanceManagement',
      icon: '#iconyijicaidan',
      roles: [
        'ACC_PLAN_R', 'ACC_PLAN_W',
        'ACC_APPROVAL_R', 'ACC_APPROVAL_SR',
        'ACC_APPROVAL_HIS_R',
        'ACC_HIS_R',
        'ACC_BILLS_R'
      ]
    },
    children: [
      {
        path: 'acceptanceBillsList',
        component: () => import(/* webpackChunkName: "AcceptanceBillsPageList" */ '@/views/acceptance/acceptance-receipt/AcceptanceBillsPageList.vue'),
        name: 'AcceptanceBillsPageList',
        meta: {
          title: 'acceptanceBillsList',
          icon: '#iconerjicaidan',
          roles: ['ACC_BILLS_R'],
          keepAlive: true
        }
      },
      {
        path: 'availableAcceptanceDetail/:id',
        component: () => import(/* webpackChunkName: "AvailableAcceptanceDetail" */ '@/views/acceptance/acceptance-receipt/AvailableAcceptanceDetail.vue'),
        name: 'AvailableAcceptanceDetail',
        meta: {
          title: 'acceptanceBillsDetail',
          hidden: true,
          noCache: true,
          roles: ['ACC_BILLS_R']
        }
      },
      {
        path: 'AcceptanceReceipt',
        component: () => import(/* webpackChunkName: "AcceptanceReceipt" */ '@/views/acceptance/acceptance-receipt/AcceptanceReceiptPageList.vue'),
        name: 'AcceptanceReceiptPageList',
        meta: {
          title: 'acceptanceReceive',
          icon: '#iconerjicaidan',
          roles: ['ACC_PLAN_R', 'ACC_PLAN_W'],
          keepAlive: true
        }
      },
      {
        path: 'acceptanceApproval',
        component: () => import(/* webpackChunkName: "acceptanceApproval" */ '@/views/acceptance/acceptance-receipt/ApproveAcceptancePageList.vue'),
        name: 'ApproveAcceptancePageList',
        meta: {
          title: 'acceptanceApproval',
          icon: '#iconerjicaidan',
          roles: ['ACC_APPROVAL_R', 'ACC_PLAN_W', 'ACC_APPROVAL_SR'],
          keepAlive: true
        }
      },
      {
        path: 'acceptanceApprovalDetail/:id',
        component: () => import(/* webpackChunkName: "acceptanceApprovalDetail" */ '@/views/acceptance/acceptance-receipt/ApproveAcceptanceDetail.vue'),
        name: 'acceptanceApprovalDetail',
        meta: {
          title: 'acceptanceApprovalDetail',
          hidden: true,
          noCache: true,
          roles: ['ACC_APPROVAL_R', 'ACC_PLAN_W', 'ACC_APPROVAL_SR']
        }
      },
      {
        path: 'acceptanceApprovalHistory',
        component: () => import(/* webpackChunkName: "AcceptanceApprovalHistoryPageList" */ '@/views/acceptance/acceptance-receipt/AcceptanceApprovalHistoryPageList.vue'),
        name: 'AcceptanceApprovalHistoryPageList',
        meta: {
          title: 'acceptanceApprovalHistory',
          icon: '#iconerjicaidan',
          roles: ['ACC_APPROVAL_HIS_R'],
          keepAlive: true
        }
      },
      {
        path: 'acceptanceApprovalHistoryDetail/:id',
        component: () => import(/* webpackChunkName: "acceptanceApprovalHistoryDetail" */ '@/views/acceptance/acceptance-receipt/AcceptanceApprovalHistoryDetail.vue'),
        name: 'acceptanceApprovalHistoryDetail',
        meta: {
          title: 'acceptanceApprovalHistoryDetail',
          hidden: true,
          noCache: true,
          roles: ['ACC_APPROVAL_HIS_R']
        }
      },
      {
        path: 'acceptanceHistory',
        component: () => import(/* webpackChunkName: "AcceptanceHistoryPageList" */ '@/views/acceptance/acceptance-receipt/AcceptanceHistoryPageList.vue'),
        name: 'AcceptanceHistoryPageList',
        meta: {
          title: 'acceptanceHistory',
          icon: '#iconerjicaidan',
          roles: ['ACC_HIS_R'],
          keepAlive: true
        }
      },
      {
        path: 'acceptanceHistoryDetail/:id',
        component: () => import(/* webpackChunkName: "acceptanceHistoryDetail" */ '@/views/acceptance/acceptance-receipt/AcceptanceHistoryDetail.vue'),
        name: 'acceptanceHistoryDetail',
        meta: {
          title: 'acceptanceHistoryDetail',
          hidden: true,
          noCache: true,
          roles: ['ACC_HIS_R']
        }
      }
    ]
  }
]
export default acceptanceRouter
